import _slicedToArray from 'babel-runtime/helpers/slicedToArray';
import React, { useState, useEffect } from 'react';
import { withTranslator } from '@wh/ui-translations';
import { publish } from '@wh/message-bus';
import { apiCallInvalid, checkIfAccountVerified, VerificationStatus } from '..';
import VerificationInProgress from './VerificationInProgress';
import { VerificationPendingInfo, VerificationPendingAction } from './VerificationPending';
import { VerificationRejectedInfo, VerificationRejectedAction } from './VerificationRejected';
import VerificationCounter from './VerificationCounter';
import VerificationDepositLeft from './VerificationDepositLeft';
import { CLASSNAME_PREFIX } from '../componentConfig';
import './index.scss';

export var AccountVerification = function AccountVerification(_ref) {
  var t = _ref.t,
      _ref$views = _ref.views,
      views = _ref$views === undefined ? {} : _ref$views,
      links = _ref.links;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      forcePeriodInMins = _useState4[0],
      setForcePeriodInMins = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      reminderCountdown = _useState6[0],
      setReminderCountdowns = _useState6[1];

  var nullishDeposit = {
    amount: null,
    currency: ''
  };

  var _useState7 = useState(nullishDeposit),
      _useState8 = _slicedToArray(_useState7, 2),
      depositLeft = _useState8[0],
      setDepositLeft = _useState8[1];

  var handleCountdownFlag = function handleCountdownFlag(countdownFlag) {
    try {
      setStatus(countdownFlag.context.status);
      setForcePeriodInMins(countdownFlag.context.forcePeriodInMins);
      setReminderCountdowns(countdownFlag.context.reminderCountdown);
      setDepositLeft(countdownFlag.context.depositLeft);
    } catch (error) {
      setStatus(null);
      setForcePeriodInMins(null);
      setReminderCountdowns(null);
      setDepositLeft(nullishDeposit);
      publish(apiCallInvalid);
    }
  };

  useEffect(function () {
    checkIfAccountVerified(handleCountdownFlag);
  }, []);

  return React.createElement(
    'div',
    { className: CLASSNAME_PREFIX + '-account-verification' },
    status === VerificationStatus.PENDING && React.createElement(VerificationPendingInfo, { t: t }),
    status === VerificationStatus.REJECTED && React.createElement(VerificationRejectedInfo, { t: t, reminderCountdown: views.reminderCountdown }),
    [VerificationStatus.IN_PROGRESS, VerificationStatus.REJECTED_WIP, VerificationStatus.REJECTED_MV].includes(status) && React.createElement(VerificationInProgress, { t: t }),
    views.reminderCountdown && React.createElement(VerificationCounter, { forcePeriodInMins: forcePeriodInMins, reminderCountdown: reminderCountdown, t: t }),
    views.deposit && React.createElement(VerificationDepositLeft, { deposit: depositLeft, t: t }),
    status === VerificationStatus.PENDING && React.createElement(VerificationPendingAction, { t: t, links: links }),
    status === VerificationStatus.REJECTED && React.createElement(VerificationRejectedAction, { t: t, links: links })
  );
};

export default withTranslator(AccountVerification);